import { getRandomDate, getRandomInt, makeArray } from '@cy/lib/util';
import { salesFieldPack } from './salesFieldPack';
import dateFormatType from './dateFormatType';
export default {
    hub: {
        daily: [
            ...makeArray(getRandomInt(10, 50)).map((_, index) => ({
                [salesFieldPack.id]: index + 1,
                [salesFieldPack.hubName]: `테스트 입니다. ${index + 1}`,
                [salesFieldPack.date]: getRandomDate(1),
                [salesFieldPack.cacheClosingBalance]: getRandomInt(100),
                [salesFieldPack.cacheSettlementTotal]: getRandomInt(100),
                [salesFieldPack.cacheCharge]: getRandomInt(10000),
                [salesFieldPack.withdrawalAmount]: getRandomInt(10000),
                [salesFieldPack.deliveryCommission]: getRandomInt(100),
                [salesFieldPack.deliveryAmount]: getRandomInt(10000),
                [salesFieldPack.deliveryAmountCommission]: getRandomInt(100),
                [salesFieldPack.orderChannelCommission]: getRandomInt(100),
                [salesFieldPack.sharedCommission]: getRandomInt(100),
                [salesFieldPack.smsCacheDeduction]: getRandomInt(100),
                [salesFieldPack.driverVirtualAccountCharge]: getRandomInt(100),
                [salesFieldPack.driverCacheClosingBalance]: getRandomInt(100),
                [salesFieldPack.insuranceDeposit]: getRandomInt(100),
                [salesFieldPack.employmentInsuranceDeposit]: getRandomInt(100),
                [salesFieldPack.occupationalAccidentInsuranceDeposit]: getRandomInt(100),
                [salesFieldPack.vatDeposit]: getRandomInt(100),
                [salesFieldPack.franchiseeMinusCacheClosingBalance]: getRandomInt(100),
                [salesFieldPack.driverCachePlusClosingBalance]: getRandomInt(100),
                [salesFieldPack.withdrawalAvailableAmount]: getRandomInt(100),
                [salesFieldPack.other]: getRandomInt(100),
            })),
        ],
        monthly: [
            ...makeArray(getRandomInt(10, 50)).map((_, index) => ({
                [salesFieldPack.id]: index + 1,
                [salesFieldPack.hubName]: `테스트 입니다. ${index + 1}`,
                [salesFieldPack.date]: getRandomDate(1, dateFormatType.MONTH),
                [salesFieldPack.cacheClosingBalance]: getRandomInt(100),
                [salesFieldPack.cacheSettlementTotal]: getRandomInt(100),
                [salesFieldPack.cacheCharge]: getRandomInt(10000),
                [salesFieldPack.withdrawalAmount]: getRandomInt(10000),
                [salesFieldPack.deliveryCommission]: getRandomInt(100),
                [salesFieldPack.deliveryAmount]: getRandomInt(10000),
                [salesFieldPack.deliveryAmountCommission]: getRandomInt(100),
                [salesFieldPack.orderChannelCommission]: getRandomInt(100),
                [salesFieldPack.sharedCommission]: getRandomInt(100),
                [salesFieldPack.smsCacheDeduction]: getRandomInt(100),
                [salesFieldPack.driverVirtualAccountCharge]: getRandomInt(100),
                [salesFieldPack.driverCacheClosingBalance]: getRandomInt(100),
                [salesFieldPack.other]: getRandomInt(100),
            })),
        ],
        dailyDetail: [
            ...makeArray(getRandomInt(10, 50)).map((_, index) => ({
                [salesFieldPack.id]: index + 1,
                [salesFieldPack.hubName]: `테스트 입니다. ${index + 1}`,
            })),
        ],
    },
};
